

































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import ObjectSelectSearch from "./object-select-search.vue";
@Component({
  components: {
    ObjectSelectSearch
  }
})
export default class CdrDetailContentZhongyaoyinpian extends Vue {
  @Prop()
  private content: any;
  private fangshis: any[] = [
    "日一剂，水煎服",
    "日一剂，冲服",
    "日一剂，灌肠",
    "日一剂，外用",
    "日一剂，热敷"
  ];
  private hashKey: any = new Date().getTime();
  /**
   * @description 获取store中的可编辑状态
   */
  private get ifCompose() {
    return this.$store.state.cdrIfCompose;
  }
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  /**
   * @description 删除一个
   */
  private deleteOne(index) {
    this.content["value"]["饮片"].splice(index, 1);
    if (this.content["value"]["饮片"].length === 0) {
      this.content["value"]["饮片"].push({});
    }
  }
  /**
   * @description 增加一个
   */
  private addOne() {
    this.content["value"]["饮片"].push({});
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.hashKey = new Date().getTime();
  }
}
